import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppAPIConfig } from './app-api-config';

@Injectable({
  providedIn: 'root',
})
export class DiaryReportService {
  appApi = new AppAPIConfig();
  httpOptions = {};
  httpOptionsForDelete: any;
  //userId = localStorage.getItem('userid');

  constructor(private http: HttpClient) {
    this.httpOptions = {
      headers: new HttpHeaders({
        Authorization: localStorage.getItem('token'),
        'Content-Type': 'application/json',
      }),
      // observe: 'response'
    };

    this.httpOptionsForDelete = {
      headers: new HttpHeaders({
        Authorization: localStorage.getItem('token'),
        'Content-Type': 'application/json',
      }),
      body: {},
    };
  }

  refreshHttpOptions() {
    this.httpOptions = {
      headers: new HttpHeaders({
        Authorization: localStorage.getItem('token'),
        'Content-Type': 'application/json',
      }),
      // observe: 'response'
    };

    this.httpOptionsForDelete = {
      headers: new HttpHeaders({
        Authorization: localStorage.getItem('token'),
        'Content-Type': 'application/json',
      }),
      body: {},
    };
  }

  getDiaryDetailsReport(diaryForm) {
    var status = diaryForm.value.empStatus;
    var id = diaryForm.value.employee.id;
    var frmD =
      diaryForm.value.fromDate.year +
      '-' +
      diaryForm.value.fromDate.month +
      '-' +
      diaryForm.value.fromDate.day;
    var toD =
      diaryForm.value.toDate.year +
      '-' +
      diaryForm.value.toDate.month +
      '-' +
      diaryForm.value.toDate.day;
    return this.http.get(
      this.appApi.getDiaryReportsAPI +
        '/emp' +
        '?status=' +
        status +
        '&fromDate=' +
        frmD +
        '&toDate=' +
        toD +
        '&userId=' +
        id,
      this.httpOptions
    );
  }

  getDiaryReportsClientWiseExportToExcelAPI(clientId,assignmentId,fromDate,toDate){

    var httpOptionsForExportToExcel:Object = {
      headers: new HttpHeaders({
        Authorization: localStorage.getItem('token'),
        'Content-Type': 'application/json',
      }),
      responseType: 'blob'
    };
    // var status = diaryForm.value.empStatus;
    // var id = diaryForm.value.employee.id;
    // var frmD =
    //   diaryForm.value.fromDate.year +
    //   '-' +
    //   diaryForm.value.fromDate.month +
    //   '-' +
    //   diaryForm.value.fromDate.day;
    // var toD =
    //   diaryForm.value.toDate.year +
    //   '-' +
    //   diaryForm.value.toDate.month +
    //   '-' +
    //   diaryForm.value.toDate.day;
    return this.http.get(
      this.appApi.getDiaryReportsClientWiseExportToExcelAPI +
        '?clientId=' +
        clientId +
        '&fromDate=' +
        fromDate +
        '&toDate=' +
        toDate +
        '&assignmentId=' +
        assignmentId,
        httpOptionsForExportToExcel
    );
  }
  getDiaryDetailsReportForExportToExcel(diaryForm){
    var httpOptionsForExportToExcel:Object = {
      headers: new HttpHeaders({
        Authorization: localStorage.getItem('token'),
        'Content-Type': 'application/json',
      }),
      responseType: 'blob'
    };
    var status = diaryForm.value.empStatus;
    var id = diaryForm.value.employee.id;
    var frmD =
      diaryForm.value.fromDate.year +
      '-' +
      diaryForm.value.fromDate.month +
      '-' +
      diaryForm.value.fromDate.day;
    var toD =
      diaryForm.value.toDate.year +
      '-' +
      diaryForm.value.toDate.month +
      '-' +
      diaryForm.value.toDate.day;
    return this.http.get(
      this.appApi.getDiaryReportsExportToExcelAPI +
        '/emp' +
        '?status=' +
        status +
        '&fromDate=' +
        frmD +
        '&toDate=' +
        toD +
        '&userId=' +
        id,
        httpOptionsForExportToExcel
    );
  }

  getReport1(fdate, tdate, emp, empStatus, cidStr) {
    var status = empStatus;
    var id = emp;
    return this.http.get(
      this.appApi.getDiaryReportsAPI +
        '?status=Active' +
        '&fromDate=' +
        fdate +
        '&toDate=' +
        tdate +
        '&userId=' +
        emp +
        '&clientId=' +
        cidStr,
      this.httpOptions
    );
  }

  getReportForExportToExcel(fdate, tdate, emp, cidStr){
    var httpOptionsForExportToExcel:Object = {
      headers: new HttpHeaders({
        Authorization: localStorage.getItem('token'),
        'Content-Type': 'application/json',
      }),
      responseType: 'blob'
    };
    return this.http.get<any>(
      this.appApi.getDiaryReportsExportToExcelAPI +
        '?status=Active' +
        '&fromDate=' +
        fdate +
        '&toDate=' +
        tdate +
        '&userId=' +
        emp +
        '&clientId=' +
        cidStr,
        httpOptionsForExportToExcel
    );
  }

  getMyLeavesReport(userId, fYId) {
    return this.http.get(
      this.appApi.getDiaryReportsAPI +
        '/myLeaves' +
        '?userId=' +
        userId +
        '&FyId=' +
        fYId,
      this.httpOptions
    );
  }

  getEmpByBranchRole(branch, role) {
    return this.http.get(
      this.appApi.getDiaryReportsAPI +
        '/userByRoleBranch' +
        '?branch=' +
        branch +
        '&roles=' +
        role,
      this.httpOptions
    );
  }

  getEmpByBranchRoleYear(partnerId, role,fyId) {
    return this.http.get(
      this.appApi.getDiaryReportsAPI +
        '/userByRolePartnerFy' +
        '?partnerId=' +
        partnerId +
        '&roles=' +
        role + '&fy='+fyId,
      this.httpOptions
    );
  }

  getEmpByBranchRoleMultiPartnerYear(partnerId, role,fyId) {
    return this.http.get(
      this.appApi.getDiaryReportsAPI +
        '/userByRoleMultiPartnerFy' +
        '?partnerId=' +
        partnerId +
        '&roles=' +
        role + '&fy='+fyId,
      this.httpOptions
    );
  }



  getIndividualLeaveReport(userId, year, month) {
    return this.http.get(
      this.appApi.getIndividualLeaveReportAPI +
        'details/' +
        userId +
        '/' +
        month +
        '/' +
        year,
      this.httpOptions
    );
  }

  getDiaryClosingDate(){
    return this.http.get(
      this.appApi.diaryAPI +'/closing-date',
      this.httpOptions
    );
  }
}
